var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLadyWithKite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 626,
    viewBox: "0 0 275 626",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_25982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.2 625.4C188.741 625.4 213.5 618.909 213.5 610.9C213.5 602.892 188.741 596.4 158.2 596.4C127.659 596.4 102.9 602.892 102.9 610.9C102.9 618.909 127.659 625.4 158.2 625.4Z",
    fill: "#CAC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.8 452.7C220.8 474.8 202.8 491.8 180.7 491.8C158.6 491.8 140.6 474.8 140.6 452.7C140.6 430.6 158.6 412.6 180.7 412.6C202.8 412.6 220.8 430.6 220.8 452.7Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2.7351,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9 487.1C162.9 487.1 148.7 487.1 139.4 505.2C130 523.3 132.9 532.4 132.9 532.4C132.9 532.4 137.4 555.2 132 562.1L223.9 577.6C223.9 577.6 213.9 547.4 213.5 534.9C213.1 522.4 207.2 491.2 186.7 487.1C166.2 482.9 162.9 487.1 162.9 487.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1 568.6L153.3 607.3H164L170.2 568.6H178.6V607.3H190.4L194.8 564.8L146.8 550.1L151.1 568.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.8 453.1C220.8 475.2 202.8 492.2 180.7 492.2C158.6 492.2 140.6 475.2 140.6 453.1C140.6 431 158.6 413 180.7 413C202.8 413 220.8 430.9 220.8 453.1Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2.7351,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 403.3C185 403.3 155.8 388.8 142.8 422.3C131.8 450.8 133.6 446.6 127 454.6C120.4 462.6 137.2 477.1 145.9 470.9C154.6 464.7 157.8 418.5 173.6 419C189.3 419.5 204.1 422.5 205.5 436.4C206.8 450.3 204 449.5 199.8 460.2C197.4 466.2 189.4 495.7 234 493.9C234 493.9 209.5 490 228.2 475.1C246.9 460.2 247.6 388.2 185 403.3Z",
    fill: "#26B0A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9 520.7C140.9 520.7 115.7 499.1 128.2 492.3C136.3 487.8 139.1 470 168.2 491.8L140.9 520.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M220.8 452.7C220.8 474.8 202.8 491.8 180.7 491.8C158.6 491.8 140.6 474.8 140.6 452.7C140.6 430.6 158.6 412.6 180.7 412.6C202.8 412.6 220.8 430.6 220.8 452.7Z",
    stroke: "#020203",
    strokeWidth: 2.7351,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.8 442.4C159.8 442.4 163.7 445.4 169.4 445.4",
    stroke: "#020203",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4 451C180.4 451 183.4 453.3 187.8 453.3",
    stroke: "#020203",
    strokeWidth: 2.3182,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1 612.1C151.1 612.1 158.5 606.9 159.6 604.5H161.8L164.1 613.6H160.2L160 608C160 608 158.6 614.5 152.4 614.2C146.2 613.8 151.1 612.1 151.1 612.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.3 612.1C191.3 612.1 186 606.9 185.2 604.5H180.8L181.9 613.6H184.7L184.9 608C184.9 608 185.9 614.5 190.4 614.2C194.9 613.8 191.3 612.1 191.3 612.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2 484.8L161.3 509.3L180.7 491.8",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 574.3C206 581.5 208.4 588.9 215.8 593.9C227.9 602 224.3 604 273.5 616.1",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5 572.8C203.7 568.2 203.5 565.4 202.5 561.7C199.9 552.3 189.1 548.4 189.1 548.4C177.233 542.1 148.4 522 128 492",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 493.1C127 493.1 67.1 414.1 68.1 269.4",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 252.6C27.8 251.6 27.7 250.5 27.7 249.4C27.7 237.8 37.9999 228.5 50.5999 228.5C56.5 228.5 61.9 230.5 66 233.9C70 227.9 77.3 223.9 85.5 223.9C96.5 223.9 105.6 230.9 107.9 240.3C112 236.9 117.4 234.8 123.4 234.8C136.1 234.8 146.3 244.2 146.3 255.7C146.3 267.3 136 276.6 123.4 276.6C121.7 276.6 120.1 276.4 118.5 276.1C115.7 284.8 106.9 291.2 96.5 291.2C93.4 291.2 90.5 290.6 87.8 289.6C82.8 295.5 74.8999 299.4 66.0999 299.4C55.2999 299.4 45.9 293.7 41.5 285.4C38.7 286.8 35.6 287.6 32.2 287.6C21.5 287.6 12.7 279.6 12.7 269.8C12.8 261.5 19.3 254.4 28 252.6Z",
    fill: "white",
    stroke: "#B4B4B4",
    strokeWidth: 3.2831,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4002 257.1C70.4002 257.1 81.2002 118.9 36.5002 108.8",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3 257.3C64.3 257.3 72.1 255.6 76.5 260L64.3 257.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3 257.3C64.3 257.3 72.1 255.6 76.5 260",
    stroke: "#B4B4B4",
    strokeWidth: 2.1544,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9001 262.6C95.9001 262.6 101 249 116.9 257.6L95.9001 262.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9001 262.6C95.9001 262.6 101 249 116.9 257.6",
    stroke: "#B4B4B4",
    strokeWidth: 2.1544,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.3752 105.05L49.4251 143L62.625 90.2002L10.3752 105.05Z",
    fill: "#E60A58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 476.6C128.9 475.1 130.8 474.5 132.4 475.4C133.9 476.3 134.5 478.2 133.6 479.8C132.7 481.4 129.3 482.8 127.8 482C126.3 481.1 127.1 478.1 128 476.6Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2 495.6C125.8 500.2 133.4 498.8 136.3 494.4C139.2 490 137.8 484.1 133.4 481.2C129 478.4 123.1 479.7 120.2 484.1C118 487.6 120.7 491.1 123.2 495.6Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 1.9972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 490.5L136.3 487.8",
    stroke: "#020203",
    strokeWidth: 1.9972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 483.7L128.5 485.9",
    stroke: "#020203",
    strokeWidth: 1.9972,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.2 533.3C184.2 529.2 176.2 534.3 175 540.8C173.8 547.2 177.9 553.4 184.1 554.6C190.4 555.8 196.5 551.6 197.7 545.2C198.7 540.1 194.1 537.3 189.2 533.3Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2.4532,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9 548.7L181.5 541.3",
    stroke: "#020203",
    strokeWidth: 2.4532,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.9 552.3L186.4 544.4",
    stroke: "#020203",
    strokeWidth: 2.4532,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_25982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274.5,
    height: 625.4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadyWithKite);
export default __webpack_public_path__ + "static/media/lady-with-kite.7e63e6ebba00a2dbf74e89131ccef404.svg";
export { ForwardRef as ReactComponent };